// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ResponsiveImage_wrapper__mZ4Co","is_borderRadius":"ResponsiveImage_is_borderRadius__BSCkR"};